import { useParams } from 'react-router-dom';
import { useGetMerchantConfigLogsQuery, useGetMerchantConfigsByAMCQuery } from '@/services';
import AuditHistory from '@/components/AuditHistory';

export default function MerchantConfigHistory() {
    const { configId, id: amcId } = useParams<{ configId: string; id: string }>();
    const { data: merchantConfigs } = useGetMerchantConfigsByAMCQuery(amcId!, { skip: !amcId });
    const { data, isLoading, error } = useGetMerchantConfigLogsQuery(configId!, { skip: !configId });

    // Find the specific merchant config by ID
    const merchantConfig = merchantConfigs?.find(config => config.id === configId);

    return (
        <AuditHistory
            title="History"
            entityName={merchantConfig?.merchantId ? `Merchant Config (${merchantConfig.merchantId})` : 'Merchant Config'}
            backLink={configId && amcId ? {
                to: `/amcs/${amcId}/merchant-configs`,
                label: 'Back to Merchant Config'
            } : undefined}
            data={data}
            isLoading={isLoading}
            error={error}
            emptyMessage="No merchant config history found."
        />
    );
}
